export default "__VITE_ASSET__a4e2ebcc__"